var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGEinline = function SvgGEinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1092_13250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.857 23.923 0 23.753c.212-2.28.424-4.647 2.57-6.436 1.704-1.416 4.426-.831 5.775-.416.263-1.06.33-3.663.136-6.318C2.578 7.361 3.46.568 3.469.5l1.848.263c-.034.237-.729 5.885 4.47 8.396l.483.229.042.525c.297 3.545.365 7.972-1.026 8.896l-.407.272-.458-.187c-.848-.339-3.51-1.094-4.656-.144-1.552 1.298-1.721 3.096-1.908 5.173Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.494 24.5c-.017-.068-.475-1.696 0-3.452.144-.525.679-1.738 2.722-1.56.89.076 1.68.551 2.095 1.272.119.204.713.916 3.231 1.34 3.664.619 8.218-3.74 9.55-7.751.89-2.663.958-6.564-.628-8.854-.84-1.204-2.078-1.849-3.68-1.908-4.504-.161-5.48 2.773-5.488 2.807l-.263.865-.873-.238C6.886 6.14 6.42 2.383 6.632.525l1.857.212c-.017.136-.314 3.087 1.459 4.19.755-1.264 2.671-3.342 6.903-3.189 2.197.076 3.977 1.01 5.148 2.705 2.027 2.926 1.874 7.497.865 10.508-1.629 4.893-6.954 9.786-11.627 9.006-2.375-.398-3.901-1.153-4.537-2.239-.11-.195-.356-.33-.645-.347-.263-.026-.704-.026-.763.178-.33 1.246 0 2.442 0 2.46l-1.798.508V24.5Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.107 8.735h-1.713V7.022a.291.291 0 0 0-.289-.289h-1.874a.291.291 0 0 0-.288.289v1.713H13.23a.291.291 0 0 0-.289.288v1.874c0 .144.12.289.289.289h1.713v1.713c0 .144.119.288.288.288h1.874a.291.291 0 0 0 .289-.288v-1.713h1.713a.291.291 0 0 0 .288-.289V9.023a.31.31 0 0 0-.288-.288Z",
    fill: "#D9516C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1092_13250"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgGEinline;